/*
* @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「用于pdf 前面打勾选择框」
 * @modify Date:2021-2-29 16:43
 */

<template>
  <div class="cAgreeChoice-container" @click="agrees">
    <li class="select-item" :class="agree ? 'select-active' : ''">
      <img :src="imgurl" />
      <span> {{ text }}</span>
    </li>
  </div>
</template>

<script>
export default {
  props: ['text', 'agree', 'isTwo'],
  data() {
    return {
      isRead: this.agree,
      isRead2: this.agree,
      isAgree: this.agree,
      imgurl: this.agree
        ? require('@/assets/img/checkbox_t.svg')
        : require('@/assets/img/checkbox_f.svg')
    };
  },
  methods: {
    handelSelect(agree) {
      this.$emit('selectClick', !agree);
    },
    agrees() {
      if (this.isTwo) {
        if (this.isRead != '' && this.isRead2 != '') {
          if (this.isAgree) {
            this.imgurl = require('@/assets/img/checkbox_f.svg');
            this.isAgree = false;
          } else {
            this.imgurl = require('@/assets/img/checkbox_t.svg');
            this.isAgree = true;
          }
          this.$emit('selectClick', this.isAgree);
        }
      } else {
        if (this.isRead != '') {
          if (this.isAgree) {
            this.imgurl = require('@/assets/img/checkbox_f.svg');
            this.isAgree = false;
          } else {
            this.imgurl = require('@/assets/img/checkbox_t.svg');
            this.isAgree = true;
          }
          this.$emit('selectClick', this.isAgree);
        }
      }
    }
  }
};
</script>

<style lang='less' scoped>
.cAgreeChoice-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .select-item {
    cursor: pointer;
    width: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
    font-size: 0.16rem;
    color: var(--text-blackcolor);
    margin-bottom: 0.36rem;
    img {
      width: 0.28rem;
      height: 0.28rem;
      margin-right: 0.13rem;
      pointer-events: none;
      vertical-align: sub;
    }
  }
  .select-active {
    color: #333333;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Button/cArgeeButton.vue